export var authSubpages = [
    { title: "Login", isActive: false, route : "login", needUpper : true },
    { title: "Register", isActive: false, route : "reg", needUpper : true },
    { title: "Confirm code", isActive: false, route : "confirmCode", needUpper : true },
    { title: "Reset password", isActive: false, route : "resetPass", needUpper : true },
    { title: "Not found", isActive: false, route : "notfound", needUpper : true },
]; 